import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseRounded";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import "react-country-dropdown/dist/index.css";
import { useLocation } from "react-router-dom";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import store from "../../../../../store/reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import Baggage from "../../../Baggage";
import countryCodes from "../../../country-code.json";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./passengerDetails.css";

const useStyles = makeStyles((theme) => ({
  paper: {
    background: "var(--backgroundcolor)",
    color: "white",
    "& .MuiSelect-root.MuiSelect-select.MuiSelect-selectMenu.MuiInputBase-input.MuiInput-input": {
      padding: "0.75rem 1rem",
      fontSize: "15px",
    },
  },
  control: {
    // padding: "2%",
    // marginBottom: "2%",
    backgroundColor: "var(--white)",
    flexGrow: "1",
    // [theme.breakpoints.down("sm")]: {
    //   padding: "4%",
    // },
  },
  main: {
    paddingTop: "10%",
    backgroundColor: "rgb(246, 249, 252)",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
  dateField: {
    flexDirection: "row",
    flexWrap: "wrap",
    display: "flex",
    borderRadius: "5px",
    border: "1px solid #c1c7cd",
  },
  textField: {
    borderRadius: "5px",
    border: "1px solid #c1c7cd",
    // padding: "2px 10px",
  },
  input: {
    color: "var(--darker)",
    flexGrow: "1",
    padding: "0.75rem 1rem",
    fontSize: "15px",
    "& .MuiInputBase-input.MuiInput-input": {
      padding: 0,
    },
  },
  datePicker: {
    "& .MuiPickersModal-dialog": {
      backgroundColor: "var(--backgroundcolor) !important",
    },
    "& .MuiDialogActions-spacing ": {
      backgroundColor: "var(--backgroundcolor) !important",
    },
    "& .MuiDialogActions-spacing .MuiButton-label": {
      color: "var(--lighttextcolor)",
    },
    "& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root": {
      backgroundColor: "var(--backgroundcolor)  !important",
    },
    "& .MuiPickersBasePicker-container .MuiPickersBasePicker-pickerView .MuiPickersDay-day ": {
      color: "var(--darker)",
    },
    "& .MuiPickersBasePicker-container .MuiButtonBase-root.MuiIconButton-root.MuiPickersDay-day.MuiPickersDay-dayDisabled ": {
      color: "var(--lighttextcolor)",
    },
    "& .MuiPickersToolbarText-toolbarBtnSelected": {
      color: "var(--darker)",
    },
    "& .MuiPickersToolbarText-toolbarTxt": {
      color: "var(--darker)",
    },

    "& .MuiPickersBasePicker-container .MuiPickersCalendarHeader-iconButton ": {
      color: "var(--darker)",
      backgroundColor: "var(--white)",
      padding: "7px",
      margin: "0px 5px",
    },
    "& .MuiPickersCalendarHeader-switchHeader p,.MuiTypography-root.MuiPickersCalendarHeader-dayLabel.MuiTypography-caption": {
      color: "var(--darker) ",
    },
  },
  pickerInput: {
    backgroundColor: "var(--backgroundcolor)",
    color: "var(--darker)",
    padding: "3px",
    borderRadius: "5px",
    "&.hover": {
      border: "none",
      outline: "none",
    },
  },
}));

const titleOptions = [
  { value: "Mr", label: "Mr." },
  { value: "Mrs", label: "Mrs." },
  { value: "Ms", label: "Ms." },
  { value: "Miss", label: "Miss." },
  { value: "Mstr", label: "Mstr." },
];
const categoryOptions = [
  { value: "adult", label: "Adult" },
  { value: "child", label: "Child" },
  { value: "infant", label: "Infant" },
];

const ageLimits = {
  adult: { min: 18, max: 100 },
  infant: { min: 0, max: 2 },
  child: { min: 2, max: 18 },
};

const nationalityOptions = [
  { value: "us", label: "United States" },
  { value: "af", label: "Afghanistan" },
  { value: "ax", label: "Åland Islands" },
  { value: "al", label: "Albania" },
  { value: "dz", label: "Algeria" },
  { value: "as", label: "American Samoa" },
  { value: "ad", label: "Andorra" },
  { value: "ao", label: "Angola" },
  { value: "ai", label: "Anguilla" },
  { value: "aq", label: "Antarctica" },
  { value: "ag", label: "Antigua and Barbuda" },
  { value: "ar", label: "Argentina" },
  { value: "am", label: "Armenia" },
  { value: "aw", label: "Aruba" },
  { value: "au", label: "Australia" },
  { value: "at", label: "Austria" },
  { value: "az", label: "Azerbaijan" },
  { value: "bs", label: "Bahamas" },
  { value: "bh", label: "Bahrain" },
  { value: "bd", label: "Bangladesh" },
  { value: "bb", label: "Barbados" },
  { value: "by", label: "Belarus" },
  { value: "be", label: "Belgium" },
  { value: "bz", label: "Belize" },
  { value: "bj", label: "Benin" },
  { value: "bm", label: "Bermuda" },
  { value: "bt", label: "Bhutan" },
  { value: "bo", label: "Bolivia" },
  { value: "ba", label: "Bosnia and Herzegovina" },
  { value: "bw", label: "Botswana" },
  { value: "bv", label: "Bouvet Island" },
  { value: "br", label: "Brazil" },
  { value: "io", label: "British Indian Ocean Territory" },
  { value: "vg", label: "British Virgin Islands" },
  { value: "bn", label: "Brunei" },
  { value: "bg", label: "Bulgaria" },
  { value: "bf", label: "Burkina Faso" },
  { value: "bi", label: "Burundi" },
  { value: "kh", label: "Cambodia" },
  { value: "cm", label: "Cameroon" },
  { value: "ca", label: "Canada" },
  { value: "cv", label: "Cape Verde" },
  { value: "ky", label: "Cayman Islands" },
  { value: "cf", label: "Central African Republic" },
  { value: "td", label: "Chad" },
  { value: "cl", label: "Chile" },
  { value: "cn", label: "China" },
  { value: "cx", label: "Christmas Island" },
  { value: "cc", label: "Cocos [Keeling] Islands" },
  { value: "co", label: "Colombia" },
  { value: "km", label: "Comoros" },
  { value: "cg", label: "Congo - Brazzaville" },
  { value: "cd", label: "Congo - Kinshasa" },
  { value: "ck", label: "Cook Islands" },
  { value: "cr", label: "Costa Rica" },
  { value: "ci", label: "Côte d'Ivoire" },
  { value: "hr", label: "Croatia" },
  { value: "cy", label: "Cyprus" },
  { value: "cz", label: "Czech Republic" },
  { value: "dk", label: "Denmark" },
  { value: "dj", label: "Djibouti" },
  { value: "dm", label: "Dominica" },
  { value: "do", label: "Dominican Republic" },
  { value: "ec", label: "Ecuador" },
  { value: "eg", label: "Egypt" },
  { value: "sv", label: "El Salvador" },
  { value: "gq", label: "Equatorial Guinea" },
  { value: "er", label: "Eritrea" },
  { value: "ee", label: "Estonia" },
  { value: "et", label: "Ethiopia" },
  { value: "fk", label: "Falkland Islands" },
  { value: "fo", label: "Faroe Islands" },
  { value: "fj", label: "Fiji" },
  { value: "fi", label: "Finland" },
  { value: "fr", label: "France" },
  { value: "gf", label: "French Guiana" },
  { value: "pf", label: "French Polynesia" },
  { value: "tf", label: "French Southern Territories" },
  { value: "ga", label: "Gabon" },
  { value: "gm", label: "Gambia" },
  { value: "ge", label: "Georgia" },
  { value: "de", label: "Germany" },
  { value: "gh", label: "Ghana" },
  { value: "gi", label: "Gibraltar" },
  { value: "gr", label: "Greece" },
  { value: "gl", label: "Greenland" },
  { value: "gd", label: "Grenada" },
  { value: "gp", label: "Guadeloupe" },
  { value: "gu", label: "Guam" },
  { value: "gt", label: "Guatemala" },
  { value: "gg", label: "Guernsey" },
  { value: "gn", label: "Guinea" },
  { value: "gw", label: "Guinea-Bissau" },
  { value: "gy", label: "Guyana" },
  { value: "ht", label: "Haiti" },
  { value: "hm", label: "Heard Island and McDonald Islands" },
  { value: "hn", label: "Honduras" },
  { value: "hk", label: "Hong Kong SAR China" },
  { value: "hu", label: "Hungary" },
  { value: "is", label: "Iceland" },
  { value: "in", label: "India" },
  { value: "id", label: "Indonesia" },
  { value: "ir", label: "Iran" },
  { value: "iq", label: "Iraq" },
  { value: "ie", label: "Ireland" },
  { value: "im", label: "Isle of Man" },
  { value: "il", label: "Israel" },
  { value: "it", label: "Italy" },
  { value: "jm", label: "Jamaica" },
  { value: "jp", label: "Japan" },
  { value: "je", label: "Jersey" },
  { value: "jo", label: "Jordan" },
  { value: "kz", label: "Kazakhstan" },
  { value: "ke", label: "Kenya" },
  { value: "ki", label: "Kiribati" },
  { value: "xk", label: "Kosovo" },
  { value: "kw", label: "Kuwait" },
  { value: "kg", label: "Kyrgyzstan" },
  { value: "la", label: "Laos" },
  { value: "lv", label: "Latvia" },
  { value: "lb", label: "Lebanon" },
  { value: "ls", label: "Lesotho" },
  { value: "lr", label: "Liberia" },
  { value: "ly", label: "Libya" },
  { value: "li", label: "Liechtenstein" },
  { value: "lt", label: "Lithuania" },
  { value: "lu", label: "Luxembourg" },
  { value: "mo", label: "Macau SAR China" },
  { value: "mk", label: "Macedonia" },
  { value: "mg", label: "Madagascar" },
  { value: "mw", label: "Malawi" },
  { value: "my", label: "Malaysia" },
  { value: "mv", label: "Maldives" },
  { value: "ml", label: "Mali" },
  { value: "mt", label: "Malta" },
  { value: "mh", label: "Marshall Islands" },
  { value: "mq", label: "Martinique" },
  { value: "mr", label: "Mauritania" },
  { value: "mu", label: "Mauritius" },
  { value: "yt", label: "Mayotte" },
  { value: "mx", label: "Mexico" },
  { value: "fm", label: "Micronesia" },
  { value: "md", label: "Moldova" },
  { value: "mc", label: "Monaco" },
  { value: "mn", label: "Mongolia" },
  { value: "me", label: "Montenegro" },
  { value: "ms", label: "Montserrat" },
  { value: "ma", label: "Morocco" },
  { value: "mz", label: "Mozambique" },
  { value: "mm", label: "Myanmar [Burma]" },
  { value: "na", label: "Namibia" },
  { value: "nr", label: "Nauru" },
  { value: "np", label: "Nepal" },
  { value: "nl", label: "Netherlands" },
  { value: "nc", label: "New Caledonia" },
  { value: "nz", label: "New Zealand" },
  { value: "ni", label: "Nicaragua" },
  { value: "ne", label: "Niger" },
  { value: "ng", label: "Nigeria" },
  { value: "nu", label: "Niue" },
  { value: "nf", label: "Norfolk Island" },
  { value: "kp", label: "North Korea" },
  { value: "mp", label: "Northern Mariana Islands" },
  { value: "no", label: "Norway" },
  { value: "om", label: "Oman" },
  { value: "pk", label: "Pakistan" },
  { value: "pw", label: "Palau" },
  { value: "ps", label: "Palestinian Territories" },
  { value: "pa", label: "Panama" },
  { value: "pg", label: "Papua New Guinea" },
  { value: "py", label: "Paraguay" },
  { value: "pe", label: "Peru" },
  { value: "ph", label: "Philippines" },
  { value: "pn", label: "Pitcairn Islands" },
  { value: "pl", label: "Poland" },
  { value: "pt", label: "Portugal" },
  { value: "pr", label: "Puerto Rico" },
  { value: "qa", label: "Qatar" },
  { value: "re", label: "Réunion" },
  { value: "ro", label: "Romania" },
  { value: "ru", label: "Russia" },
  { value: "rw", label: "Rwanda" },
  { value: "bl", label: "Saint Barthélemy" },
  { value: "sh", label: "Saint Helena" },
  { value: "kn", label: "Saint Kitts and Nevis" },
  { value: "lc", label: "Saint Lucia" },
  { value: "mf", label: "Saint Martin" },
  { value: "pm", label: "Saint Pierre and Miquelon" },
  { value: "vc", label: "Saint Vincent and the Grenadines" },
  { value: "ws", label: "Samoa" },
  { value: "sm", label: "San Marino" },
  { value: "st", label: "São Tomé and Príncipe" },
  { value: "sa", label: "Saudi Arabia" },
  { value: "sn", label: "Senegal" },
  { value: "rs", label: "Serbia" },
  { value: "sc", label: "Seychelles" },
  { value: "sl", label: "Sierra Leone" },
  { value: "sg", label: "Singapore" },
  { value: "sk", label: "Slovakia" },
  { value: "si", label: "Slovenia" },
  { value: "sb", label: "Solomon Islands" },
  { value: "so", label: "Somalia" },
  { value: "za", label: "South Africa" },
  { value: "gs", label: "South Georgia and the South Sandwich Islands" },
  { value: "kr", label: "South Korea" },
  { value: "es", label: "Spain" },
  { value: "lk", label: "Sri Lanka" },
  { value: "sd", label: "Sudan" },
  { value: "sr", label: "Suriname" },
  { value: "sj", label: "Svalbard and Jan Mayen" },
  { value: "sz", label: "Swaziland" },
  { value: "se", label: "Sweden" },
  { value: "ch", label: "Switzerland" },
  { value: "sy", label: "Syria" },
  { value: "tw", label: "Taiwan" },
  { value: "tj", label: "Tajikistan" },
  { value: "tz", label: "Tanzania" },
  { value: "th", label: "Thailand" },
  { value: "tl", label: "Timor-Leste" },
  { value: "tg", label: "Togo" },
  { value: "tk", label: "Tokelau" },
  { value: "to", label: "Tonga" },
  { value: "tt", label: "Trinidad and Tobago" },
  { value: "tn", label: "Tunisia" },
  { value: "tr", label: "Turkey" },
  { value: "tm", label: "Turkmenistan" },
  { value: "tc", label: "Turks and Caicos Islands" },
  { value: "tv", label: "Tuvalu" },
  { value: "um", label: "U.S. Minor Outlying Islands" },
  { value: "vi", label: "U.S. Virgin Islands" },
  { value: "ug", label: "Uganda" },
  { value: "ua", label: "Ukraine" },
  { value: "ae", label: "United Arab Emirates" },
  { value: "gb", label: "United Kingdom" },
  { value: "us", label: "United States" },
  { value: "uy", label: "Uruguay" },
  { value: "uz", label: "Uzbekistan" },
  { value: "vu", label: "Vanuatu" },
  { value: "va", label: "Vatican City" },
  { value: "ve", label: "Venezuela" },
  { value: "vn", label: "Vietnam" },
  { value: "wf", label: "Wallis and Futuna" },
  { value: "eh", label: "Western Sahara" },
  { value: "ye", label: "Yemen" },
  { value: "zm", label: "Zambia" },
  { value: "zw", label: "Zimbabwe" },
];

const gender = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "others", label: "Others" },
];

const isCountry = (terminalCode) => {
  const Airport_Terminal_Codes = [
    "PYG",
    "VDY",
    "DGH",
    "GOX",
    "HGI",
    "JGB",
    "NVY",
    "RJI",
    "TEI",
    "OMN",
    "REW",
    "DIU",
    "GDB",
    "AMD",
    "AKD",
    "IXU",
    "BOM",
    "PAB",
    "BHJ",
    "IXG",
    "BDQ",
    "BHO",
    "BHU",
    "NMB",
    "GUX",
    "GOI",
    "HBX",
    "IDR",
    "JLR",
    "JGA",
    "IXY",
    "HJR",
    "KLH",
    "IXK",
    "NDC",
    "NAG",
    "ISK",
    "PNQ",
    "PBD",
    "RTC",
    "RAJ",
    "RPR",
    "SAG",
    "SSE",
    "STV",
    "UDR",
    "DBR",
    "IXV",
    "IXA",
    "IXB",
    "RGH",
    "SHL",
    "BBI",
    "CCU",
    "COH",
    "DBD",
    "RDP",
    "DEP",
    "GOP",
    "GAU",
    "GAY",
    "IMF",
    "JRG",
    "PYB",
    "IXW",
    "JRH",
    "KBK",
    "IXQ",
    "IXH",
    "IXS",
    "IXN",
    "AJL",
    "IXI",
    "LDA",
    "DIB",
    "DMU",
    "MZU",
    "IXT",
    "PAT",
    "IXR",
    "RRK",
    "RUP",
    "TEZ",
    "VTZ",
    "ZER",
    "AGR",
    "IXD",
    "ATQ",
    "AIP",
    "BKB",
    "VNS",
    "KUU",
    "BUP",
    "BEK",
    "IXC",
    "KNU",
    "DED",
    "DEL",
    "DHM",
    "GWL",
    "HSS",
    "JDH",
    "JAI",
    "JSA",
    "IXJ",
    "KQH",
    "KTU",
    "LUH",
    "IXL",
    "LKO",
    "IXP",
    "PGH",
    "SLV",
    "SXR",
    "TNI",
    "LTU",
    "TCR",
    "AGX",
    "BEP",
    "BLR",
    "IXX",
    "VGA",
    "CJB",
    "COK",
    "CCJ",
    "CDP",
    "CBD",
    "GBI",
    "HYD",
    "BPM",
    "CNN",
    "KJB",
    "IXM",
    "IXE",
    "MAA",
    "MYQ",
    "IXZ",
    "PNY",
    "PUT",
    "RMD",
    "RJA",
    "SXV",
    "SDW",
    "TJV",
    "TIR",
    "TRZ",
    "TRV",
    "WGC",
  ];
  return Airport_Terminal_Codes.includes(terminalCode);
};

const titleGenderMap = {
  Mr: "male",
  Mrs: "female",
  Ms: "female",
  Miss: "female",
  Mstr: "male",
};

const genderTitleMap = {
  male: ["Mr", "Mstr"],
  female: ["Mrs", "Ms", "Miss"],
};

function PassengerListItem(props) {
  const classes = useStyles();
  const { id } = props.data;
  const { data } = props;
  const search = useLocation().search;
  const departureDate = new URLSearchParams(search).get("departureDate");
  const flight = useSelector((state) => state.flight.selectedFlight);
  const [isIndia, setIsIndia] = useState(true);
  useEffect(() => {
    if (flight) {
      console.log(" munna flight", flight);
      if (
        flight?.countryFrom?.name == "India" &&
        flight?.countryTo?.name == "India"
      ) {
        setIsIndia(true);
      } else if (
        isCountry(flight?.slices[0]?.segments[0]?.flyFrom) &&
        isCountry(
          flight?.slices[0]?.segments[flight?.slices[0]?.segments.length - 1]
            ?.flyTo
        )
      ) {
        setIsIndia(true);
      } else {
        setIsIndia(false);
      }
    }
  }, [flight]);
  let minDate;
  let maxDate;
  switch (data.category) {
    case "adult":
      minDate = moment().subtract(100, "years");
      maxDate = moment().subtract(12, "years");
      break;
    case "child":
      minDate = moment().subtract(11, "years");
      maxDate = moment().subtract(2, "years");
      break;
    case "infant":
      minDate = moment().subtract(2, "years");
      maxDate = moment();
      break;
    default:
      break;
  }
  const dispatch = useDispatch();

  const setPassengers = (data) => {
    dispatch({ type: "SET_PASSENGERS", data });
  };

  const removePassenger = (id) => {
    const { passengers } = store.getState().flight;
    let _passengers = [...passengers];
    const ind = _passengers.findIndex((passenger) => passenger.id === id);
    _passengers.splice(ind, 1);
    setPassengers(_passengers);
  };

  const validationSchema = Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required("Required"),
      category: Yup.string().required("Required"),
      name: Yup.string().required("Required"),
      surname: Yup.string().required("Required"),
      birthday: Yup.date().required("Required"),
      nationality: Yup.string().required("Required"),
      // email: Yup.string().email().required("Required"),
      // phone: Yup.string().min(10).required("Required"),
    })
  );

  const onChange = async (e) => {
    const { passengers, phone, email } = store.getState().flight;

    if (!e.target) return;
    let { name, value } = e.target;
    if (name == "birthday" || name == "expiration") {
      value = value ? moment(value["$d"]).format("YYYY-MM-DD") : null;
    }
    let _passengers = [...passengers];
    const ind = _passengers.findIndex((pass) => pass.id === id);
    if (ind == 0 && name == "category") return;

    const obj = { ..._passengers[ind] };

    // Add title-gender validation
    if (name === "title") {
      // When title changes, update gender to match
      obj.gender = titleGenderMap[value];
    } else if (name === "gender") {
      // When gender changes, update title if current title doesn't match
      const currentTitle = obj.title;
      if (!genderTitleMap[value].includes(currentTitle)) {
        obj.title = genderTitleMap[value][0]; // Set to first valid title for gender
      }
    }

    obj[name] = value;
    if (email) {
      obj.email = email;
    }
    if (phone) {
      obj.phone = phone;
    }

    _passengers[ind] = obj;

    let isValid = false;
    isValid = await validationSchema.validate(_passengers).catch((err) => {
      console.log("ERROR----------------->>", err.name, err.errors);
    });
    if (isValid == false) return;

    dispatch({ type: "SET_PASSENGERS_LIST_VALID", data: isValid });

    setPassengers(_passengers);
  };

  const handleBaggageChange = (data) => {
    if (data) {
      const { passengers } = store.getState().flight;
      let _passengers = [...passengers];
      const ind = _passengers.findIndex((pass) => pass.id === id);
      const obj = { ..._passengers[ind] };
      obj["baggage"] = data;
      _passengers[ind] = obj;
      setPassengers(_passengers);
    }
  };

  return (
    <Paper className={classes.control} elevation={0}>
      {/* {props.canRemove ? (
        <div>
          <Button
            style={{ float: "right" }}
            size="small"
            color="error"
            variant="outlined"
            onClick={removePassenger}
          >
            <CloseIcon />
          </Button>
        </div>
      ) : (
        ""
      )} */}
      <Grid container className="passenger-box" spacing={0}>
        <Grid item xs="12" sm="12">
          <FormControl
            fullWidth
            size="sm"
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              display: "flex",
              gap: "1rem",
            }}
          >
            <Grid item xs="6" sm="6" md="3" className="flexBasis3">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Title
              </Typography>

              <Select
                fullWidth
                labelId="demo-customized-stops-label"
                id="demo-customized-stops"
                MenuProps={{
                  classes: {
                    paper: classes.paper,
                  },
                }}
                disableUnderline
                value={data.title || "Mr."}
                onChange={(e) => {
                  onChange({
                    target: { name: "title", value: e.target.value },
                  });
                }}
              >
                {titleOptions.map((item) => (
                  <MenuItem
                    style={{ color: "var(--darker)" }}
                    value={item.value}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs="12" sm="12" md="6" className="flexBasis1">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Name
              </Typography>
              <TextField
                placeholder="Enter Name"
                size="small"
                fullWidth
                value={data.name}
                id="outlined-error-helper-text"
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                  disableUnderline: true,
                }}
                onChange={(e) => {
                  onChange({ target: { name: "name", value: e.target.value } });
                  //setName(e.target.value)
                }}
              />
            </Grid>
            <Grid item xs="12" sm="12" md="6" className="flexBasis1">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Surname
              </Typography>
              <TextField
                placeholder="Enter Surname"
                size="small"
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                  disableUnderline: true,
                }}
                fullWidth
                value={data.surname}
                id="outlined-error-helper-text"
                onChange={(e) => {
                  onChange({
                    target: { name: "surname", value: e.target.value },
                  });
                  // setSurname(e.target.value)
                }}
              />
            </Grid>

            <Grid item xs="12" sm="12" md="6" className="flexBasis2">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Date of Birth
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  size="small"
                  className={classes.dateField}
                  value={data.birthday}
                  minDate={minDate}
                  maxDate={maxDate}
                  disableFuture={true}
                  InputProps={{
                    className: classes.input,
                    disableUnderline: true,
                    readOnly: true,
                  }}
                  fullWidth
                  onChange={(date) => {
                    onChange({
                      target: { name: "birthday", value: date },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "Select Date",
                        readOnly: true,
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs="12" sm="12" md="3" className="flexBasis3">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Gender
              </Typography>

              <Select
                fullWidth
                labelId="demo-customized-stops-label"
                id="demo-customized-stops"
                MenuProps={{
                  classes: {
                    paper: classes.paper,
                  },
                }}
                disableUnderline
                value={data.gender || "male"}
                onChange={(e) => {
                  onChange({
                    target: { name: "gender", value: e.target.value },
                  });
                }}
              >
                {gender.map((item) => (
                  <MenuItem
                    style={{ color: "var(--darker)" }}
                    value={item.value}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs="12" sm="12" md="3" className="flexBasis3">
              <Typography
                component="p"
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  marginBottom: "5px",
                }}
              >
                Nationality
              </Typography>
              <Select
                fullWidth
                labelId="demo-customized-stops-label"
                id="demo-customized-stops"
                MenuProps={{
                  classes: {
                    paper: classes.paper,
                  },
                }}
                disableUnderline
                value={data.nationality || "in"}
                onChange={(e) => {
                  onChange({
                    target: { name: "nationality", value: e.target.value },
                  });
                }}
              >
                {nationalityOptions.map((item) => (
                  <MenuItem
                    style={{ color: "var(--darker)" }}
                    value={item.value}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {!isIndia && (
              <>
                <Grid item xs="12" sm="12" md="6" className="flexBasis2">
                  <Typography
                    component="p"
                    style={{
                      textAlign: "left",
                      fontWeight: 600,
                      marginBottom: "5px",
                    }}
                  >
                    Passport Number
                  </Typography>
                  <TextField
                    placeholder="Enter Passport no"
                    size="small"
                    fullWidth
                    value={data.passport}
                    id="outlined-error-helper-text"
                    className={classes.textField}
                    InputProps={{
                      className: classes.input,
                      disableUnderline: true,
                    }}
                    onChange={(e) => {
                      onChange({
                        target: { name: "passport", value: e.target.value },
                      });
                      //setName(e.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs="12" sm="12" md="6" className="flexBasis2">
                  <Typography
                    component="p"
                    style={{
                      textAlign: "left",
                      fontWeight: 600,
                      marginBottom: "5px",
                    }}
                  >
                    Passport Expiration Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      inputFormat="DD/MM/YYYY"
                      size="small"
                      className={classes.dateField}
                      value={data.expiration}
                      InputProps={{
                        className: classes.input,
                        disableUnderline: true,
                      }}
                      fullWidth
                      onChange={(date) => {
                        onChange({
                          target: { name: "expiration", value: date },
                        });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            )}
          </FormControl>
        </Grid>
      </Grid>
      <Baggage
        category={data.category}
        selectedCurrency={props.selectedCurrency}
        flight={flight}
        onBaggageChange={handleBaggageChange}
      />
    </Paper>
  );
}

export default React.memo(PassengerListItem);
